<template>
    <div>
        <div class="common-header">
            <el-button
                    @click="getList()"
                    style="margin-left: 10px"
                    class="el-icon-refresh"
                    type="primary"
                    plain> 刷新
            </el-button>
            <div class="common-header-right">
                <div class="common-header-block">
                    <el-input placeholder="请输入玩家昵称或ID" v-model="searchVal">
                        <template slot="prepend">玩家</template>
                    </el-input>
                </div>
                <div class="common-header-block">
                    <el-button type="primary" @click="getList()">搜索</el-button>
                </div>
            </div>
        </div>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    :data="userLeaveTableList.beanList"
                    :row-key="row=>JSON.stringify(row)"
                    height="100%">
                <el-table-column label="玩家id" min-width="180" align="center" prop="userRandomId"/>
                <el-table-column label="玩家昵称" min-width="180" align="center" prop="userNickname"/>
                <el-table-column label="房间ID" min-width="150" align="center"  prop="roomId"/>
                <el-table-column label="房间名称" min-width="150" align="center"  prop="roomName"/>
                <el-table-column label="房间盲注级别" min-width="120" align="center">
                  <template slot-scope="scope">{{scope.row.mangzhu|blindNoteNumber2}}</template>
                </el-table-column>
                <el-table-column label="房间类型" min-width="120" align="center">
                  <template slot-scope="scope">{{scope.row.roomType|roomTypeName}}</template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                background
                layout="prev,pager,next,jumper"
                :page-size="20"
                :pager-count="5"
                :total="userLeaveTableList.total"
                @current-change="getList($event)"
                :current-page="currentPage"/>

    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                searchVal: '',
                roomType:  [{label: '普通局', value: 61}, {label: '奥马哈', value: 91}],
                currentPage: 1,
            }
        },
        computed: {
            ...mapState('userLeaveTable', ['userLeaveTableList']),
        },
        created() {
            this.getList();
        },
        methods: {
            ...mapActions('userLeaveTable', ['getUserLeaveTableList']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getUserLeaveTableList({
                    page,
                    // roomType: this.roomType,
                    userRandomId: this.searchVal
                }).then(() => {
                    this.loading = false
                })
            },
        }
    }
</script>